<template>
  <router-view />
</template>
<script>
export default {
  setup() {
    return {};
  },
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
}
html {
  scroll-behavior: smooth;
  scrollbar-color: #000000 #ffffff;
  scrollbar-width: thin;
}
body {
  background-color: #262626;
}
* {
  box-sizing: border-box;
  font-family: "Proxima Nova";
  margin: 0;
  -webkit-tap-highlight-color: transparent;
  scroll-behavior: smooth;
  scrollbar-color: #60cb89 transparent;
  scrollbar-width: thin;
}
p {
  overflow-wrap: anywhere;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
a {
  color: white;
}
:root {
  --slider-connect-bg: #60cb89; /* Цвет активной (левой) части */
  --slider-bg: #355d45; /* Цвет неактивной (правой) части */
  --slider-handle-bg: #60cb89; /* Цвет ползунка */
}
.multiselect__tags {
  background: transparent;
  border: 1px solid #60cb89;
  min-height: 0;
  padding: 5px;
}
.multiselect__input {
  background-color: transparent;
  color: white;
  font-size: 14px;
  margin-bottom: 0;
}
.multiselect {
  color: rgba(255, 255, 255, 0.6);
  min-height: 20px;
}
.multiselect__input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.multiselect__content-wrapper {
  background-color: #1a1a1a;
  border: 1px solid #60cb89;
}
.multiselect__option {
  font-size: 14px;
  padding: 6px 12px;
  min-height: 0;
}
.multiselect__option--selected {
  background-color: #60cb89;
  color: white;
}
.multiselect__option--selected::after {
  color: white;
}
.multiselect__placeholder {
  margin-bottom: 0;
  padding: 0 0 0 5px;
}
.multiselect__select {
  height: fit-content;
  right: 0px;
  top: 25%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.multiselect__option::after {
  line-height: 28px;
}
.multiselect__single {
  background-color: #60cb89;
  width: fit-content;
  color: white;
  padding-right: 5px;
}
.input {
  background: transparent;
  border: 1px solid #60cb89;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.input.medium {
  padding: 10px;
}
.input span {
  font-size: 12px !important;
}
.button {
  background-color: #60cb89;
  color: white;
  border-radius: 5px;
  padding: 7px 30px;
  width: fit-content;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Убираем стрелочки в Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.Vue-Toastification__toast {
  transform: scale(0.8) !important;
  min-width: 0px !important;
}
.Vue-Toastification__icon {
  margin: 0 !important;
}
@import "@vueform/slider/themes/default.css";
@import "vue-multiselect/dist/vue-multiselect.min.css";
@font-face {
  font-family: "Proxima Nova";
  src: url("assets/fonts/proximanova_regular.ttf");
}
@font-face {
  font-family: "Proxima Nova Bold";
  src: url("assets/fonts/proximanova_bold.otf");
}
</style>
